<div class="overlay__panel__wrapper">
	<div class="product__wrapper">
		<ul class="product__list">
			<li
				*ngIf="search.length"
				class="search__feedback"
				(click)="searchProduct(search)"
			>
				<p id="search">
					<i class="fa-solid fa-magnifying-glass"></i> Pesquisar por:
					<strong>{{ search }}</strong>
				</p>
			</li>

			<li *ngIf="search.length && !products?.length">
				<p>
					Nenhum resultado encontrado para: <strong>{{ search }}</strong>
				</p>
			</li>

			<li *ngIf="!search.length && !products?.length && !isLoading">
				<p>Nenhum produto cadastrado.</p>
			</li>

			<li class="spinner" *ngIf="isLoading">
				<p-progressSpinner
					strokeWidth="4"
					[style]="{ width: '50px', height: '50px' }"
				></p-progressSpinner>
			</li>
			<ng-container *ngIf="!isLoading && products?.length">
				<span id="suggestions">Produtos sugeridos</span>
				<li *ngFor="let product of products | slice: 0:10">
					<div class="product__item">
						<div
							class="product__item__wrapper"
							[routerLink]="['/product', product.id]"
						>
							<img
								*ngIf="product.pictures[0] as mainPicture; else defaultImage"
								class="product__item__image"
								[src]="mainPicture.url"
								[alt]="mainPicture.description"
								[style.object-fit]="objectFit"
							/>
							<ng-template #defaultImage>
								<div class="product__item__image" style="font-size: 0.3rem">
									<app-img-default></app-img-default>
								</div>
							</ng-template>

							<div class="product__item__content">
								<strong class="product__item__name">
									{{ product.name }}
								</strong>
								<div class="product__item__price">
									<small class="product__item__cod">
										SKU: {{ product.sku }}
									</small>

									<span *appDisableIfVisitor class="product__item__prices">
										<small
											*ngIf="product.originalPrice"
											class="product__price__before"
										>
											De:
											<del>
												{{ product.originalPrice | currency: 'R$' }}
											</del>
										</small>

										<strong [class.promotional-price]="product.originalPrice">
											<small *ngIf="product.originalPrice"> Por: </small>
											{{ product.prices[0].price | currency: 'R$' }}
											{{ product.sellingUnit }}
										</strong>
									</span>
								</div>
							</div>
						</div>

						<p-divider *appDisableIfVisitor layout="vertical"></p-divider>

						<div *appDisableIfVisitor class="product__item__actions">
							<ng-container
								*appProductAvailability="{ product, type: 'btn-icon' }"
							>
								<p-button
									*appClearIfHasFeature="'enableProductPacking'"
									class="button__w__full"
									styleClass="p-button-sm add__item__button"
									label=""
									icon="fa-solid fa-cart-plus"
									[disabled]="cartFacade.requesting"
									(onClick)="addToCart(product)"
								></p-button
							></ng-container>
						</div>
					</div>

					<p-divider></p-divider>
				</li>
			</ng-container>
		</ul>
	</div>
</div>
